// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3PuZu","item":"PaymentsMobile_item__3YpIV","label":"PaymentsMobile_label__gJoRt","amount":"PaymentsMobile_amount__3EE91"};